import { createContext, useContext, useRef } from "react";


const PageContext = createContext();

const initialValues = {
  document: { title: "", file: "" },
};

export const PageProvider = ({ children }) => {
  const docuemntArray = useRef();

  const handleSubmit = {};

  const handleDocumentAdd = () => {
    docuemntArray.current.push({ title: "", file: "" });
  };

  const handleDocumentDelete = (index) => () => {
    docuemntArray.current.remove(index);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        docuemntArray,
        handleDocumentDelete,
        handleDocumentAdd,
      }}>
      {children}
    </PageContext.Provider>
  );
};

export const useDocumentProvider = () => {
  return useContext(PageContext);
};
